import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { LoaderComponent } from './loader/loader.component';
import { SafePipe } from 'src/app/Pipes/safe.pipe';
import { NgOtpInputComponent } from './ng-otp-input/ng-otp-input.component';
import { KeysPipe } from '../pipes/keys.pipe';
import { NumberOnlyDirective } from '../directives/number-only.directive';
import { ElipsisPipe } from 'src/app/Pipes/elipsis.pipe';
import { TooltipModule } from '@looorent/ng2-tooltip-directive';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TooltipModule
    ],
    declarations: [
        LoaderComponent,
        NgOtpInputComponent,
        KeysPipe, 
        NumberOnlyDirective,
        SafePipe,
        ElipsisPipe
    ],
    exports: [
        LoaderComponent,
        NgOtpInputComponent,
        SafePipe,
        ElipsisPipe
    ],
    providers: [
        KeysPipe
    ]
})
export class SharedComponentModule {
}
